import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { twMerge } from '../../utils/twMerge.js';
import { Text } from '../Text/Text.js';
/**
 * The `<Paragraph>` component represents a paragraph. Paragraphs can be any structural grouping of related content,
 * such as images or form fields.
 */
export const Paragraph = forwardRef(function Paragraph(props, forwardedRef) {
    return _jsx(Text, { ...props, ref: forwardedRef, elementType: "p", className: twMerge('mb-4', props.className) });
});
//# sourceMappingURL=Paragraph.js.map